import { axiosModules } from "@qubit-utill/src";

export default {
  //Decode Encode Hash 정보 조회
  getDecodeEncodeHashInfo: (type) => axiosModules.get(`/decodeencodehash/${type}`),
  //Decode Encode Hash 정보 리스트
  getDecodeEncodeHashList: (data) => axiosModules.post(`/pfilter/decodeencodehash`, data),
};
